import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { PagerDataObject } from '../../../entities/pagerDataObject';
import { RiskService } from '../../../services/riskService';
import { SharedService } from '../../../services/sharedService';

@Component({
  selector: 'risk-score-list',
  templateUrl: './risk-score-list.component.html',
})
export class RiskScoreListComponent implements OnInit, OnDestroy {
  year: string;
  indicatorId: string;
  indicatorName: string;
  columns: Array<any>;
  metaInfo: string[];
  data: PagerDataObject;
  private dataSub$ = new Subject<any>();
  private subscription: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private riskService: RiskService,
    private sharedService: SharedService
  ) {}

  ngOnInit() {
    this.columns  = this.riskService.getColumnsResults();
    this.metaInfo = ['view', ...this.riskService.getMetaResultsInfo()];

    this.subscription = this.dataSub$.pipe(
      switchMap(filter => this.riskService.getData(filter))
    ).subscribe(data => {
      this.data = data;
    });

    this.route.queryParams.subscribe(params => {
      this.year = params['year'];
      this.indicatorId = params['indicatorId'];
      this.indicatorName = params['indicatorName'];
    });
  }

  onGridQuery(query) {
    const q = typeof query === 'string' ? query : query.query;
    const filter = q + '&indicatorId=' + this.indicatorId + '&sector=Default';
    this.dataSub$.next(filter);
  }

  onButtonClick(event: any) {
    if (event.cell && event.cell.key === 'view') {
      this.router.navigate(['/indicator/risk-breakdown'], {
        queryParams: {
          match: event.row.match,
          companyName: event.row.companyName,
          year: this.year,
          sector: 'Default',
          indicatorId: this.indicatorId,
          indicatorName: this.indicatorName
        }
      });
    }
  }

  goBack() {
    this.router.navigate(['/indicator/risk-results']);
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }
}
